import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../store';
import { Menu, MenuItem } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { changePassword, logout } from '../../store/login';

import { BelfiusText } from '../custom';
import { BelfiusTooltip } from '../custom/belfius-tooltip';
import { Dispatch } from 'redux';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import styles from './footer.module.css';

interface PropsFromState {
  readonly currentLanguage: string;
  readonly username: string;
  readonly firstName: string;
  readonly lastName: string;
}

interface PropsFromDispatch {
  readonly logout: Function;
  readonly changePassword: Function;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class Footer extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
    this.localization.setLanguage(this.props.currentLanguage);
  }

  state = {
    anchorSettings: null,
  };

  handleClick = (event: { currentTarget: any; }) => {
    this.setState({ anchorSettings: event.currentTarget });
  }

  handleClose = () => {
    this.setState({ anchorSettings: null });
  }

  handleLogout = () => {
    this.props.logout();
  }

  handleChangePassword = () => {
    this.props.changePassword();
  }

  handleNavigateToManual = () => {
    this.handleClose();
    window.open(require('../../assets/docs/' + this.localization.get('shared.userManualPdf')));
  }

  handleNavigateToQuickReferenceGuide = () => {
    this.handleClose();
    window.open(require('../../assets/videos/' + this.localization.get('shared.quickReferenceGuideMp4')));
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.info}>
          <BelfiusText>
            {this.localization.getFormatedDate(new Date(), this.props.currentLanguage)} / {this.props.username} / {this.props.firstName} {this.props.lastName}
          </BelfiusText>
        </div>
        <div>
          <BelfiusTooltip title={this.localization.get('shared.settings')}>
            <div>
              <SettingsIcon
                aria-owns='simple-menu'
                aria-haspopup='true'
                onClick={this.handleClick}
                className={styles.settings}>Settings</SettingsIcon>
            </div>
          </BelfiusTooltip>
          <Menu
            id='simple-menu'
            anchorEl={this.state.anchorSettings}
            open={Boolean(this.state.anchorSettings)}
            onClose={this.handleClose}
          >
            <MenuItem onClick={this.handleNavigateToQuickReferenceGuide}>{this.localization.get('shared.quickReferenceGuide')}</MenuItem>
            <MenuItem onClick={this.handleNavigateToManual}>{this.localization.get('shared.userManual')}</MenuItem>
            <MenuItem onClick={this.handleChangePassword}>{this.localization.get('shared.changePassword')}</MenuItem>
            <MenuItem onClick={this.handleLogout}>
              <div className={styles.logoutButton}>
              <img alt="" className={styles.logoutImage} src={require('../../assets/images/logout.png')} /></div>
              <div className={styles.logoutLabel}></div>{this.localization.get('shared.logoff')}</MenuItem>
          </Menu>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ shared }: ApplicationState) => ({
  currentLanguage: shared.currentLanguage,
  username: shared.currentUser,
  firstName: shared.firstName,
  lastName: shared.lastName
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  logout: () => dispatch(logout()),
  changePassword: () => dispatch(changePassword())
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
